import { Injectable } from '@angular/core';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class DocPackService {
    constructor(public datatask: DataTaskService) {}

    public async getDocPack(params: GetDocPackParams): Promise<DocPackGet> {
        return (await this.datatask.Post(3289, params))[0];
    }

    /**
     * Saves the given doc pack.
     *
     * @datatask 3313
     * @datataskName sp_ws_p2_docpack_save
     * @param params the doc pack to save.
     * @returns
     */
    public async saveDocPack(params: DocPackGet): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(3313, params))[0];
    }

    /**
     * Deletes the given doc pack.
     *
     * @datatask 3317
     * @datataskName sp_ws_p2_docpack_delete
     * @param params the doc pack to delete
     * @returns promise containing validation.
     */
    public async deleteDocPack(params: DocPackGet): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(3317, params))[0];
    }

    /**
     * Retrieves list of file data for the pages to include in the docpack.
     *
     * @datatask 3316
     * @datataskName sp_ws_p2_w_docpack_filecontent_pages_list
     * @param params the docpack to get content for.
     * @returns promise containing list of content.
     */
    public async getDocPackPages(params: GetDocPackParams): Promise<DocPackPage[]> {
        return this.datatask.Post(3316, params);
    }

    /**
     * Resets the doc pack front page.
     *
     * @datatask 3314
     * @datataskName sp_ws_p2_docpack_html_update
     * @param params the doc pack to reset.
     * @returns promise containing validation.
     */
    public async resetDocPack(params: DocPackGet): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(3314, params))[0];
    }
}

export interface GetDocPackParams {
    docpack_keyno: string;
}

export interface DocPackGet {
    docpack_keyno: string;
    docpack_name: string;
    project_no_and_name: string;
    docpackchapter_keyno_selected: string;
    html_text_frontpage: string;
    html_text_indexpage: string;
    docpacktype_keyno: string;
}

export interface DocPackPage {
    filepages_keyno: `${number}`;
    rotation_degrees?: `${number}`;
    pagetitle: string;
    chaptertitle: string;
    filecontent_type: string;
    filename: string;
    docarc_keyno: `${number}`;
    filecontent_base64: string;
    filecontent_to_merge_base64: string;
    level: '1' | '2' | '3';
}
